import React from 'react';

import { Icon } from '@iq/react-components';
import Tooltip from '../../../../Tooltip/Tooltip';

export const buildCopyAction = (onCopy, tooltipText) => ({
  text: (
    <span className="menu-item-with-info">
      Copy settings
      <Tooltip content={tooltipText}>
        <span>
          <Icon
            icon="he-info"
            size="sm"
          />
        </span>
      </Tooltip>
    </span>
  ),
  action: onCopy,
  placement: 'before',
});

export const buildPasteAction = ({ copiedSettings, currentSettings, onPaste }) => {
  const isIdentical =
    copiedSettings &&
    JSON.stringify(copiedSettings.stateChangeSettings) === JSON.stringify(currentSettings);
  const disabled = !copiedSettings || isIdentical;
  const tooltipText = !copiedSettings
    ? 'No notification settings copied yet.'
    : isIdentical
      ? 'Copied settings are already identical.'
      : 'Paste and overwrite current settings.';

  return {
    text: (
      <span className={`menu-item-with-info${disabled ? ' menu-item-with-info--disabled' : ''}`}>
        Paste settings
        <Tooltip content={tooltipText}>
          <span>
            <Icon
              icon="he-info"
              size="sm"
            />
          </span>
        </Tooltip>
      </span>
    ),
    action: () => {
      if (copiedSettings && !isIdentical) {
        onPaste();
      }
    },
    placement: 'before',
  };
};

export const buildResetAction = (onReset, tooltipText) => ({
  text: (
    <span className="menu-item-with-info">
      Reset to match role
      <Tooltip content={tooltipText}>
        <span>
          <Icon
            icon="he-info"
            size="sm"
          />
        </span>
      </Tooltip>
    </span>
  ),
  action: onReset,
  placement: 'before',
});
